<template>
  <RouterLink
    :to="to"
    :class="rootClassName"
  >
    <div :class="$style.iconWrapper">
      <Icon
        :name="icon"
        :class="$style.icon"
      />
    </div>
    <div :class="$style.text">
      <slot />
    </div>
  </RouterLink>
</template>

<script>
import { string, oneOf } from 'vue-types';

import Icon from '@/components/Icon.vue';
import { isRouterLinkTo } from '@/types/routerLink';

export const ThemesEnum = {
  GREEN: 'green',
  BLUE: 'blue',
};

const classNameByTheme = {
  [ThemesEnum.GREEN]: 'rootGreen',
  [ThemesEnum.BLUE]: 'rootBlue',
};

export default {
  components: {
    Icon,
  },

  props: {
    to: isRouterLinkTo.isRequired,
    theme: oneOf(Object.values(ThemesEnum)).def(ThemesEnum.GREEN),
    icon: string().isRequired,
  },

  computed: {
    rootClassName() {
      return this.$style[classNameByTheme[this.theme]];
    },
  },
};
</script>

<style lang="scss" module>
@import "~@/styles/variables.scss";

.root {
  border-radius: 10px;
  padding: 12px;
}

.rootGreen {
  composes: root;
  background: linear-gradient(88.93deg, #31BC69 1.83%, #089E4E 98.17%);
}

.rootBlue {
  composes: root;
  background: linear-gradient(145.47deg, #0095FF -36.18%, #0855C4 150.8%);
}

.iconWrapper {
  width: 36px;
  height: 36px;
  background-color: rgba(#fff, .3);
  border-radius: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  color: $color-white;
  font-size: 24px;
}

.text {
  color: rgba(255, 255, 255, 0.8);
  line-height: 17px;
}
</style>
